<template>
  <page-view
    :is-loading="loading"
    :isAgentPage="true"
    :plyr-page-view="true"
    :content-height="pageViewHeight"
    :custom-header-class="'plyr-page-view-header-css'"
    :custom-content-class="'plyr-page-view-content-css'"
    :custom-container-class="'plyr-page-view-container-css'"
    style="margin: 0; padding: 0"
  >
    <template #header>
      <base-header :title="'Tutor'" :subtitle="agentData.name">
        <template #actions v-if="isMobileBreakpoint">
          <div class="d-flex justify-space-between w-full" style="width: 100%">
            <v-row
              v-if="isMobileBreakpoint"
              ref="back"
              @click="$router.push({ name: 'Tutor' })"
              class="header__back"
              align="center"
              justify="center"
              align-content="center"
              no-gutters
            >
              <span class="header__back--icon">
                <span>
                  <v-icon :size="isMobileBreakpoint ? 20 : 16">
                    panda-back
                  </v-icon>
                </span>
              </span>
            </v-row>
            <v-row
              v-if="isMobileBreakpoint"
              justify="center"
              class="video-page__header--sub d-flex align-center"
              no-gutters
            >
              <div>
                <span
                  ref="subtitle"
                  class="body-bold-small text-container"
                  :title="agentData.name"
                >
                  {{ agentData.name }}
                </span>
              </div>
            </v-row>
            <!-- <v-tooltip
              bottom
              persistent
              :disabled="!disabledStatus(agentData.status)"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-btn
                    icon
                    @click="openMenu(agentData, $event)"
                    :disabled="
                      isRemovingVideo || disabledStatus(agentData.status)
                    "
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </div>
              </template>

              <span class="d-flex" style="pointer-events: all">
                <span style="width: 190px">
                  {{
                    $t('message.pages.pandaAssist.hoverTooltipDisabledButtons')
                  }}
                </span>
              </span>
            </v-tooltip> -->
            <v-menu
              min-width="100px"
              bottom
              left
              offset-y
              v-model="menuVisible"
              :close-on-content-click="true"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :disabled="
                    isRemovingVideo || disabledStatus(agentData.status) || !hasEditVideoPerm
                  "
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="toggleStatus(agentData)" :disabled="!hasEditVideoPerm">
                  <v-list-item-title class="body-regular-smaller">
                    {{
                      agentData.status === 'disabled'
                        ? $t('message.pages.pandaAssist.active')
                        : $t('message.pages.pandaAssist.disabled')
                    }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="renameItem(agentData)" :disabled="!hasEditVideoPerm">
                  <v-list-item-title class="body-regular-smaller">{{
                    $t('message.pages.pandaAssist.rename')
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="removeItem(agentData)" :disabled="!hasEditVideoPerm">
                  <v-list-item-title class="body-regular-smaller removeText">{{
                    $t('message.pages.pandaAssist.remove')
                  }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <v-row class="pa-0 ml-0" style="width: 100%">
            <v-col cols="6" class="pl-0">
              <v-tooltip
                bottom
                persistent
                :disabled="!disabledStatus(agentData.status)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <base-btn
                      style="width: 100%"
                      type="tertiary"
                      @click="openTestModal"
                      :disabled="
                        isRemovingVideo || disabledStatus(agentData.status)
                      "
                    >
                      {{ $t('message.pages.AssistentIntern.actions.test') }}
                    </base-btn>
                  </div>
                </template>

                <span class="d-flex" style="pointer-events: all">
                  <span style="width: 190px">
                    {{
                      $t(
                        'message.pages.pandaAssist.hoverTooltipDisabledButtons'
                      )
                    }}
                  </span>
                </span>
              </v-tooltip>
            </v-col>
            <v-col cols="6">
              <v-tooltip
                bottom
                persistent
                :disabled="!disabledStatus(agentData.status)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <base-btn
                      style="width: 100%"
                      @click="openEmbedModal"
                      :disabled="
                        isRemovingVideo || disabledStatus(agentData.status)
                      "
                    >
                      {{ $t('message.pages.AssistentIntern.actions.embed') }}
                    </base-btn>
                  </div>
                </template>

                <span class="d-flex" style="pointer-events: all">
                  <span style="width: 190px">
                    {{
                      $t(
                        'message.pages.pandaAssist.hoverTooltipDisabledButtons'
                      )
                    }}
                  </span>
                </span>
              </v-tooltip>
            </v-col>
          </v-row>
        </template>
        <template #actions v-else>
          <span
            v-if="
              disabledStatus(agentData.status) &&
              agentData.status !== 'failed' &&
              agentData.status !== 'disabled'
            "
            class="d-flex"
          >
            <div id="nalp" class="nalps mr-2"></div>

            <v-tooltip
              bottom
              :disabled="!disabledStatus(agentData.status) && isTooltipVisible"
              :open-on-hover="false"
              v-model="isTooltipVisible"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-tag
                  v-bind="attrs"
                  v-on="on"
                  @mouseenter="mouseOverTooltip"
                  @mouseleave="mouseLeaveTooltip"
                  type="default"
                >
                  {{
                    agentData.updating
                      ? $t('message.pages.pandaAssist.updating')
                      : $t('message.pages.pandaAssist.converting')
                  }}
                </v-tag>
              </template>
              <span
                class="d-flex"
                style="pointer-events: all"
                @mouseenter="mouseOverTooltip"
                @mouseleave="mouseLeaveTooltip"
              >
                <span style="width: 190px">
                  {{ $t('message.pages.pandaAssist.hoverTooltipMessage') }}
                </span>
                <base-btn
                  @click="goToEmbedArticle"
                  type="neutral"
                  size="xsmall"
                  style="width: 110px; align-self: center"
                >
                  {{ $t('message.embedModal.knowMore') }}
                  <v-icon size="16" class="ml-1">mdi-open-in-new</v-icon>
                </base-btn>
              </span>
            </v-tooltip>
          </span>
          <span v-else-if="agentData.status === 'failed'" class="d-flex">
            <v-tooltip bottom persistent :close-delay="1500">
              <template v-slot:activator="{ on, attrs }">
                <v-tag
                  v-bind="attrs"
                  v-on="on"
                  @mouseenter="toggleHover(agentData, true)"
                  @mouseleave="toggleHover(agentData, false)"
                  :type="getTagType(agentData.status)"
                >
                  {{ $t('message.pages.pandaAssist.generationError') }}
                </v-tag>
              </template>

              <span class="d-flex" style="pointer-events: all">
                <span style="width: 160px">
                  {{ $t('message.pages.pandaAssist.hoverTooltipErrorMessage') }}
                </span>
                <div
                  style="z-index: 9999; cursor: pointer"
                  class="ml-4 d-flex align-center"
                >
                  <base-btn
                    @click.stop="openErrorHelp"
                    type="neutral"
                    size="xsmall"
                  >
                    {{ $t('message.knowMore') }}
                    <v-icon size="16">mdi-open-in-new</v-icon>
                  </base-btn>
                </div>
              </span>
            </v-tooltip>
          </span>
          <v-tag v-else :type="getTagType(agentData.status)">
            {{ getStatusText(agentData.status) }}
          </v-tag>

          <v-tooltip
            bottom
            persistent
            :disabled="!disabledStatus(agentData.status)"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <base-btn
                  type="tertiary"
                  @click="openTestModal"
                  :disabled="
                    isRemovingVideo || disabledStatus(agentData.status) || !hasEditVideoPerm
                  "
                >
                  {{ $t('message.pages.AssistentIntern.actions.test') }}
                </base-btn>
              </div>
            </template>

            <span class="d-flex" style="pointer-events: all">
              <span style="width: 190px">
                {{
                  $t('message.pages.pandaAssist.hoverTooltipDisabledButtons')
                }}
              </span>
            </span>
          </v-tooltip>
          <v-tooltip
            bottom
            persistent
            :disabled="!disabledStatus(agentData.status)"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <base-btn
                  @click="openEmbedModal"
                  :disabled="
                    isRemovingVideo || disabledStatus(agentData.status)
                  "
                >
                  {{ $t('message.pages.AssistentIntern.actions.embed') }}
                </base-btn>
              </div>
            </template>

            <span class="d-flex" style="pointer-events: all">
              <span style="width: 190px">
                {{
                  $t('message.pages.pandaAssist.hoverTooltipDisabledButtons')
                }}
              </span>
            </span>
          </v-tooltip>
          <v-tooltip
            v-if="!isMobileBreakpoint"
            bottom
            persistent
            :disabled="!disabledStatus(agentData.status)"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-btn
                  icon
                  @click="openMenu(agentData, $event)"
                  :disabled="
                    isRemovingVideo || disabledStatus(agentData.status) || !hasEditVideoPerm
                  "
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </div>
            </template>

            <span class="d-flex" style="pointer-events: all">
              <span style="width: 190px">
                {{
                  $t('message.pages.pandaAssist.hoverTooltipDisabledButtons')
                }}
              </span>
            </span>
          </v-tooltip>
          <v-menu
            v-if="!isMobileBreakpoint"
            min-width="100px"
            ref="menuRef"
            absolute
            :position-x="menuX"
            :position-y="menuY"
            v-model="menuVisible"
            offset-y
            :close-on-content-click="true"
          >
            <!-- Itens do menu -->
            <v-list>
              <v-list-item @click="toggleStatus(agentData)">
                <v-list-item-title class="body-regular-smaller">
                  {{
                    agentData.status === 'disabled'
                      ? $t('message.pages.pandaAssist.active')
                      : $t('message.pages.pandaAssist.disabled')
                  }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="renameItem(agentData)" :disabled="!hasEditVideoPerm">
                <v-list-item-title class="body-regular-smaller">{{
                  $t('message.pages.pandaAssist.rename')
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="removeItem(agentData)" :disabled="!hasEditVideoPerm">
                <v-list-item-title class="body-regular-smaller removeText">{{
                  $t('message.pages.pandaAssist.remove')
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </base-header>
    </template>
    <template #content>
      <div class="grid">
        <div class="grid__preview" v-if="!isMobileBreakpoint">
          <div
            class="grid__preview--container d-flex justify-center align-center bg-dark--ignore"
            style="max-width: 608px"
          >
            <v-card
              elevation="0"
              flat
              class="preview__chat rounded-lg bg-dark--ignore"
            >
              <div
                class="preview__chat--title d-flex justify-space-between align-center px-4 py-2 bg-dark--ignore"
              >
                <span class="body-label-caption py-1">
                  {{ agentData.name }}
                </span>
                <span
                  ><v-icon
                    class="body-label-caption"
                    size="14px"
                    v-if="agentData.open_new_tab"
                    >mdi-open-in-new</v-icon
                  ></span
                >
              </div>
              <div class="preview__chat--chat bg-dark--ignore">
                <div class="preview__chat--chat-bot body-regular-small">
                  <span class="message">{{ agentData.initial_question }}</span>
                </div>
                <div
                  class="preview__chat--chat-suggestions bg-dark--ignore"
                  v-if="agentData.question_suggestions"
                >
                  <div class="pa-4">
                    <span
                      class="body-label-caption textType6--text justify-end d-flex"
                      >{{
                        $t(
                          'message.pages.AssistentIntern.previewSuggestQuestions'
                        )
                      }}</span
                    >
                    <span class="d-flex justify-end suggestion-btn">
                      <span
                        size="small"
                        type="tertiary"
                        class="bg-dark--ignore cursor-default body-bold-smaller textType5--text d-flex"
                      >
                        <span v-if="agentData.suggestions.length > 0">
                          {{ agentData.suggestions[0] }}
                        </span>
                        <span v-else>
                          <v-tooltip bottom style="width: 200px !important">
                            <template v-slot:activator="{ on, attrs }">
                              <div
                                v-bind="attrs"
                                v-on="on"
                                id="nalp"
                                class="nalps ml-4"
                              ></div>
                            </template>
                            <div style="max-width: 200px !important">
                              <span>
                                {{
                                  $t(
                                    'message.pages.pandaAssist.hoverTooltipDisabledButtons'
                                  )
                                }}
                              </span>
                            </div>
                          </v-tooltip>
                        </span>
                        <v-divider></v-divider>
                        <span class="d-flex align-center">
                          <v-icon size="16" class="pandaGo"> panda-go </v-icon>
                        </span>
                      </span>
                    </span>
                    <span class="d-flex justify-end suggestion-btn">
                      <span
                        size="small"
                        type="tertiary"
                        class="bg-dark--ignore cursor-default body-bold-smaller textType5--text d-flex"
                      >
                        <span v-if="agentData.suggestions.length > 0">
                          {{ agentData.suggestions[1] }}
                        </span>
                        <span v-else>
                          <v-tooltip bottom style="width: 200px !important">
                            <template v-slot:activator="{ on, attrs }">
                              <div
                                v-bind="attrs"
                                v-on="on"
                                id="nalp"
                                class="nalps ml-4"
                              ></div>
                            </template>
                            <div style="max-width: 200px !important">
                              <span>
                                {{
                                  $t(
                                    'message.pages.pandaAssist.hoverTooltipDisabledButtons'
                                  )
                                }}
                              </span>
                            </div>
                          </v-tooltip></span
                        >
                        <v-divider></v-divider>
                        <v-icon size="16" class="pandaGo"> panda-go </v-icon>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="preview__advice d-flex align-end">
                  <div
                    class="preview__advice--message d-flex flex-column align-center justify-end"
                  >
                    <div>
                      <span class="body-bold-small">{{
                        $t('message.pages.pandaAssist.messagePreviewChat')
                      }}</span>
                    </div>
                    <span class="body-regular-smaller text-center">{{
                      $t('message.pages.pandaAssist.descriptionPreviewChat')
                    }}</span>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
        </div>
        <!-- dialogs -->
        <embed-modal :assistant="agentData"></embed-modal>
        <test-modal :assistant="agentData"></test-modal>
        <CreatePandaAssist
          :dialog-visible="dialogVisible"
          :is-update-videos="agentData"
          @update:dialog-visible="dialogVisible = $event"
        />

        <div class="grid__control" :class="{ 'pt-0': isMobileBreakpoint }">
          <div class="my-4" v-if="isMobileBreakpoint">
            <span
              v-if="
                disabledStatus(agentData.status) &&
                agentData.status !== 'failed' &&
                agentData.status !== 'disabled'
              "
              class="d-flex"
            >
              <div id="nalp" class="nalps mr-2"></div>

              <v-tooltip
                bottom
                :disabled="
                  !disabledStatus(agentData.status) && isTooltipVisible
                "
                :open-on-hover="false"
                v-model="isTooltipVisible"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-tag
                    v-bind="attrs"
                    v-on="on"
                    @mouseenter="mouseOverTooltip"
                    @mouseleave="mouseLeaveTooltip"
                    type="default"
                  >
                    {{
                      agentData.updating
                        ? $t('message.pages.pandaAssist.updating')
                        : $t('message.pages.pandaAssist.converting')
                    }}
                  </v-tag>
                </template>
                <span
                  class="d-flex"
                  style="pointer-events: all"
                  @mouseenter="mouseOverTooltip"
                  @mouseleave="mouseLeaveTooltip"
                >
                  <span style="width: 190px">
                    {{ $t('message.pages.pandaAssist.hoverTooltipMessage') }}
                  </span>
                  <base-btn
                    @click="goToEmbedArticle"
                    type="neutral"
                    size="xsmall"
                    style="width: 110px; align-self: center"
                  >
                    {{ $t('message.embedModal.knowMore') }}
                    <v-icon size="16" class="ml-1">mdi-open-in-new</v-icon>
                  </base-btn>
                </span>
              </v-tooltip>
            </span>
            <span v-else-if="agentData.status === 'failed'" class="d-flex">
              <v-tooltip bottom persistent :close-delay="1500">
                <template v-slot:activator="{ on, attrs }">
                  <v-tag
                    v-bind="attrs"
                    v-on="on"
                    @mouseenter="toggleHover(agentData, true)"
                    @mouseleave="toggleHover(agentData, false)"
                    :type="getTagType(agentData.status)"
                  >
                    {{ $t('message.pages.pandaAssist.generationError') }}
                  </v-tag>
                </template>

                <span class="d-flex" style="pointer-events: all">
                  <span style="width: 160px">
                    {{
                      $t('message.pages.pandaAssist.hoverTooltipErrorMessage')
                    }}
                  </span>
                  <div
                    style="z-index: 9999; cursor: pointer"
                    class="ml-4 d-flex align-center"
                  >
                    <base-btn
                      @click.stop="openErrorHelp"
                      type="neutral"
                      size="xsmall"
                    >
                      {{ $t('message.knowMore') }}
                      <v-icon size="16">mdi-open-in-new</v-icon>
                    </base-btn>
                  </div>
                </span>
              </v-tooltip>
            </span>
            <v-tag v-else :type="getTagType(agentData.status)">
              {{ getStatusText(agentData.status) }}
            </v-tag>
          </div>
          <AgentTabs> </AgentTabs>

          <portal to="agent-general" :order="1">
            <BaseAlert
              v-if="agentData.status === 'disabled'"
              type="warning"
              class="ml-1"
              :title="$t('message.pages.AssistentIntern.disabledChat')"
              :description="
                $t('message.pages.AssistentIntern.activeToShowChat')
              "
              ><base-btn
                size="small"
                type="secondary"
                class="mt-2"
                style="height: auto; min-height: 32px"
                @click="toggleStatus(agentData)"
                >{{
                  $t('message.pages.AssistentIntern.actions.activeChat')
                }}</base-btn
              >
            </BaseAlert>
            <v-row
              class="mt-md-6 mt-3"
              :class="{ 'mt-2': !isMobileBreakpoint }"
            >
              <v-col cols="12" class="mx-2">
                <v-row>
                  <v-col
                    cols="12"
                    class="d-flex align-center justify-space-between"
                  >
                    <div class="d-flex flex-column">
                      <span class="featTitle">{{
                        $t('message.pages.AssistentIntern.activeChat')
                      }}</span>
                      <span class="featSubtitle">{{
                        $t('message.pages.AssistentIntern.descActiveChat')
                      }}</span>
                    </div>
                    <v-tooltip
                      :disabled="agentData.status !== 'failed'"
                      bottom
                      persistent
                      :close-delay="1500"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <v-switch
                            @change="updateStatusAgent"
                            class="mt-0"
                            v-model="isAssistantReady"
                            hide-details
                            :disabled="
                              agentData.status !== 'disabled' &&
                              agentData.status !== 'ready' || !hasEditVideoPerm
                            "
                          >
                          </v-switch>
                        </div>
                      </template>

                      <span class="d-flex" style="pointer-events: all">
                        <span style="width: 160px">
                          {{
                            $t(
                              'message.pages.pandaAssist.hoverTooltipErrorMessage'
                            )
                          }}
                        </span>
                        <div
                          style="z-index: 9999; cursor: pointer"
                          class="ml-4 d-flex align-center"
                        >
                          <base-btn
                            @click.stop="openErrorHelp"
                            type="neutral"
                            size="xsmall"
                          >
                            {{ $t('message.knowMore') }}
                            <v-icon size="16">mdi-open-in-new</v-icon>
                          </base-btn>
                        </div>
                      </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row :class="{ 'flex-column': isMobileBreakpoint }">
                  <v-col cols="6" class="d-flex align-center">
                    <div class="d-flex flex-column">
                      <span class="featTitle">{{
                        $t('message.pages.AssistentIntern.nameChat')
                      }}</span>
                      <span class="featSubtitle">{{
                        $t('message.pages.AssistentIntern.descNameChat')
                      }}</span>
                    </div>
                  </v-col>
                  <v-col
                    :cols="!isMobileBreakpoint ? 6 : 0"
                    class="d-flex align-center"
                    :class="{ 'pl-0': isMobileBreakpoint }"
                  >
                    <v-input
                      :placeholder="agentData.name"
                      hide-details
                      @input="checkChanges"
                      @change="checkChanges"
                      v-model="agentData.name"
                      style="margin: 0 0.5rem"
                      :disabled="!hasEditVideoPerm"
                    ></v-input>
                  </v-col>
                </v-row>
                <v-row :class="{ 'flex-column': isMobileBreakpoint }">
                  <v-col class="d-flex align-center justify-space-between">
                    <div class="d-flex flex-column">
                      <span class="featTitle">{{
                        $t('message.pages.AssistentIntern.initialQuestion')
                      }}</span>
                      <span class="featSubtitle">{{
                        $t('message.pages.AssistentIntern.descInitialQuestion')
                      }}</span>
                    </div>
                  </v-col>
                  <v-col
                    :cols="!isMobileBreakpoint ? 6 : 0"
                    :class="{ 'pl-0': isMobileBreakpoint }"
                    class="d-flex align-center"
                  >
                    <v-input
                      :placeholder="agentData.initial_question"
                      v-model="agentData.initial_question"
                      @input="checkChanges"
                      @change="checkChanges"
                      hide-details
                      style="margin: 0 0.5rem"
                      :disabled="agentData.status === 'disabled' || !hasEditVideoPerm"
                    >
                    </v-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    class="d-flex align-center justify-space-between"
                  >
                    <div class="d-flex flex-column">
                      <span class="featTitle">{{
                        $t('message.pages.AssistentIntern.suggestQuestions')
                      }}</span>
                      <span class="featSubtitle">{{
                        $t('message.pages.AssistentIntern.descSuggestQuestions')
                      }}</span>
                    </div>
                    <v-switch
                      @change="checkChanges"
                      class="mt-0"
                      hide-details
                      v-model="agentData.question_suggestions"
                      :disabled="agentData.status === 'disabled' || !hasEditVideoPerm"
                    >
                    </v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    class="d-flex align-center justify-space-between"
                  >
                    <div class="d-flex flex-column">
                      <span class="featTitle">{{
                        $t('message.pages.AssistentIntern.newTab')
                      }}</span>
                      <span class="featSubtitle">{{
                        $t('message.pages.AssistentIntern.descNewTab')
                      }}</span>
                    </div>
                    <v-switch
                      @change="checkChanges"
                      v-model="agentData.open_new_tab"
                      class="mt-0"
                      hide-details
                      :disabled="agentData.status === 'disabled' || !hasEditVideoPerm"
                    >
                    </v-switch>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </portal>

          <portal to="agent-instructions">
            <BaseAlert
              v-if="agentData.status === 'disabled'"
              type="warning"
              class="ml-1"
              :title="$t('message.pages.AssistentIntern.disabledChat')"
              :description="
                $t('message.pages.AssistentIntern.activeToShowChat')
              "
              ><base-btn
                size="small"
                type="secondary"
                style="height: auto; min-height: 32px"
                @click="toggleStatus(agentData)"
                >{{
                  $t('message.pages.AssistentIntern.actions.activeChat')
                }}</base-btn
              >
            </BaseAlert>
            <v-row>
              <v-col
                cols="12"
                class="mx-2 mt-3"
                :class="{ 'mt-10': !isMobileBreakpoint }"
              >
                <v-row
                  class="mr-2"
                  :class="{ 'flex-column': isMobileBreakpoint }"
                >
                  <v-col
                    :cols="!isMobileBreakpoint ? 7 : 0"
                    class="d-flex flex-column pr-0"
                  >
                    <span class="body-bold-medium">{{
                      $t('message.pages.AssistentIntern.customInstructions')
                    }}</span>
                    <span class="body-regular-smaller">{{
                      $t('message.pages.AssistentIntern.prompTextExplanation')
                    }}</span>
                    <span class="cursor-pointer"
                      ><a type="secondary" size="xsmall" @click="openHelp"
                        >{{
                          $t(
                            'message.pages.AssistentIntern.actions.checkHowUse'
                          )
                        }}
                        <v-icon size="11px">mdi-open-in-new</v-icon></a
                      ></span
                    >
                  </v-col>
                  <v-col
                    :cols="!isMobileBreakpoint ? 5 : 0"
                    class="align-center d-flex"
                    :class="{ 'pl-0 justify-end': !isMobileBreakpoint }"
                  >
                    <base-btn
                      type="secondary"
                      size="small"
                      class="instructionsBtn"
                      @click="openInstructionTipsModal"
                    >
                      {{ $t('message.pages.pandaAssist.instructionsTips') }}
                    </base-btn>
                  </v-col>

                  <v-dialog v-model="showInstructionTipsModal" max-width="600">
                    <v-card>
                      <v-card-title class="body-bold-medium">
                        {{
                          $t('message.pages.pandaAssist.instructionTips.title')
                        }}
                      </v-card-title>
                      <v-card-text>
                        <span class="body-regular-smaller textType6--text">
                          {{
                            $t(
                              'message.pages.pandaAssist.instructionTips.description'
                            )
                          }}
                          <a type="secondary" size="xsmall" @click="openHelp">
                            {{
                              $t(
                                'message.pages.AssistentIntern.actions.checkHowUse'
                              )
                            }}
                            <v-icon size="11px">mdi-open-in-new</v-icon>
                          </a>
                        </span>
                        <div
                          v-for="(tip, index) in tips"
                          :key="index"
                          class="d-flex mt-5"
                        >
                          <span class="indexNumber mr-3 body-bold-smaller">{{
                            index + 1
                          }}</span>
                          <span style="display: grid">
                            <span class="body-bold-small textType3--text">
                              {{
                                $t(
                                  `message.pages.pandaAssist.instructionTips.tips.${
                                    index + 1
                                  }.title`
                                )
                              }}
                            </span>
                            <span class="body-regular-smal textType5--text">
                              {{
                                $t(
                                  `message.pages.pandaAssist.instructionTips.tips.${
                                    index + 1
                                  }.description`
                                )
                              }}
                            </span>
                          </span>
                        </div>
                      </v-card-text>
                      <v-col class="pa-0 mt-1 mb-4">
                        <v-divider></v-divider>
                      </v-col>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <base-btn
                          type="tertiary"
                          class="mb-6 mr-3"
                          text
                          @click="showInstructionTipsModal = false"
                        >
                          {{
                            $t(
                              'message.pages.pandaAssist.instructionTips.tips.close'
                            )
                          }}
                        </base-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-col class="d-flex flex-column py-0">
                    <v-col class="d-flex flex-column pa-0">
                      <v-textarea
                        :placeholder="
                          $t('message.pages.AssistentIntern.insertHere')
                        "
                        class="mt-2 textarea-flex"
                        :counter="5000"
                        @input="checkChanges"
                        @change="checkChanges"
                        :maxlength="5000"
                        no-resize
                        rows="17"
                        style="font-size: 14px"
                        v-model="agentData.prompt"
                        :disabled="agentData.status === 'disabled' || !hasEditVideoPerm"
                        append-icon="panda-help-outline"
                        @click:append="openHelp"
                      >
                        <template #append>
                          <v-tooltip bottom style="width: 200px !important">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                class="helper-cursor-pointer"
                                size="16"
                                @click="openHelp"
                              >
                                panda-help-outline
                              </v-icon>
                            </template>
                            <div style="max-width: 200px !important">
                              <span
                                >{{
                                  $t(
                                    'message.pages.pandaAssist.helpTooltipTitle'
                                  )
                                }}
                                <br />
                                "{{
                                  $t(
                                    'message.pages.pandaAssist.helpTooltipText'
                                  )
                                }}"
                              </span>
                            </div>
                          </v-tooltip>
                        </template>
                      </v-textarea>
                    </v-col>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </portal>

          <portal to="agent-knowledge">
            <BaseAlert
              v-if="agentData.status === 'disabled'"
              type="warning"
              class="ml-1"
              :title="$t('message.pages.AssistentIntern.disabledChat')"
              :description="
                $t('message.pages.AssistentIntern.activeToShowChat')
              "
              ><base-btn
                style="height: auto; min-height: 32px"
                size="small"
                type="secondary"
                @click="toggleStatus(agentData)"
                >{{
                  $t('message.pages.AssistentIntern.actions.activeChat')
                }}</base-btn
              >
            </BaseAlert>
            <v-row>
              <v-col
                cols="12"
                class="mx-2 mt-3"
                :class="{ 'mt-10': !isMobileBreakpoint }"
              >
                <v-row>
                  <v-col
                    cols="12"
                    class="d-flex align-center ga-4 justify-space-between"
                  >
                    <span class="body-bold-medium">
                      {{ $t('message.pages.AssistentIntern.videos') }}
                    </span>
                    <v-tooltip
                      bottom
                      :disabled="
                        !disabledStatus(agentData.status) ||
                        agentData.status == 'disabled'
                      "
                    >
                      <template v-slot:activator="{ on, addvid }">
                        <div v-bind="addvid" v-on="on">
                          <base-btn
                            type="secondary"
                            size="small"
                            class="mr-2"
                            @click="openModalUpdateVideos"
                            :disabled="
                              isRemovingVideo ||
                              disabledStatus(agentData.status) || !hasEditVideoPerm
                            "
                            ><v-icon>mdi-plus</v-icon
                            >{{
                              $t('message.pages.AssistentIntern.addVideo')
                            }}</base-btn
                          >
                        </div>
                      </template>

                      <span class="d-flex" style="pointer-events: all">
                        <span
                          v-if="
                            disabledStatus(agentData.status) &&
                            agentData.status !== 'failed'
                          "
                          style="width: 190px"
                        >
                          {{
                            $t(
                              'message.pages.pandaAssist.hoverTooltipDisabledButtons'
                            )
                          }}
                        </span>
                        <span
                          v-else-if="agentData.status === 'failed'"
                          style="width: 190px"
                        >
                          {{
                            $t(
                              'message.pages.pandaAssist.hoverTooltipErrorMessage'
                            )
                          }}
                        </span>
                      </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row class="mr-2 py-2">
                  <v-col
                    v-for="(video, index) in agentData.videos"
                    :key="index"
                    cols="12"
                    class="d-flex align-center py-1 justify-space-between pr-0"
                  >
                    <div class="d-flex">
                      <v-icon
                        v-if="video.process_status === 'failed'"
                        class="mr-2 disabledText"
                        size="16"
                      >
                        panda-video
                      </v-icon>
                      <div
                        v-else-if="
                          (isRemovingVideo &&
                            video.id === videoMarkRemove.id) ||
                          video.process_status === 'queued' ||
                          video.process_status === 'processing'
                        "
                        id="nalp"
                        class="nalps mr-2"
                      ></div>
                      <img
                        v-else
                        src="@/assets/pandaIcons/mini-player.svg"
                        class="mr-2"
                      />
                      <span
                        class="body-regular-small"
                        :class="{
                          disabledText: video.process_status == 'failed',
                          'truncate-text':
                            isMobileBreakpoint && !video.chat_is_visible,
                        }"
                      >
                        {{ video.title }}
                      </span>
                    </div>
                    <div class="d-flex no-wrap align-center">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-on="on" v-bind="attrs">
                            <v-tag
                              v-if="!video.chat_is_visible"
                              type="neutral"
                              size="xsmall"
                              class="mr-1"
                              >{{
                                $t(
                                  'message.pages.AssistentIntern.disabledVideoChat'
                                )
                              }}</v-tag
                            >
                          </div>
                        </template>
                        <span
                          >{{
                            $t(
                              'message.pages.AssistentIntern.disabledVideoChatTooltip'
                            )
                          }}
                        </span>
                      </v-tooltip>
                      <v-tooltip
                        v-model="isTooltipVisibility[video.id]"
                        bottom
                        persistent
                        transition="none"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            @mouseenter="mouseOverErrorTooltip(video.id)"
                            @mouseleave="mouseLeaveErrorTooltip(video.id)"
                          >
                            <v-tag
                              v-if="video.process_status === 'failed'"
                              type="error"
                              size="small"
                              class="mr-1"
                            >
                              {{
                                $t('message.pages.pandaAssist.generationError')
                              }}
                            </v-tag>
                          </div>
                        </template>

                        <span
                          class="d-flex"
                          style="pointer-events: all"
                          @mouseenter="cancelHideTooltip(video.id)"
                          @mouseleave="mouseLeaveErrorTooltip(video.id)"
                        >
                          <span style="width: 160px">
                            {{
                              $t(
                                'message.pages.pandaAssist.hoverTooltipErrorMessage'
                              )
                            }}
                          </span>
                          <div
                            style="z-index: 9999; cursor: pointer; width: 110px"
                            class="ml-4 d-flex align-center"
                          >
                            <base-btn
                              @click.stop="openErrorHelp"
                              type="neutral"
                              size="xsmall"
                            >
                              {{ $t('message.knowMore') }}
                              <v-icon size="16">mdi-open-in-new</v-icon>
                            </base-btn>
                          </div>
                        </span>
                      </v-tooltip>
                      <v-menu
                        min-width="100px"
                        ref="SubmenuRef"
                        bottom
                        left
                        offset-y
                        :close-on-content-click="true"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            type="secondary"
                            v-bind="attrs"
                            v-on="on"
                            size="small"
                            icon
                            :disabled="
                              (isRemovingVideo &&
                                video.id === videoMarkRemove.id) ||
                              video.process_status === 'queued' ||
                              video.process_status === 'processing' || !hasEditVideoPerm
                            "
                          >
                            <v-icon size="14px">mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <!-- Itens do menu -->
                        <v-list class="gap-2">
                          <v-list-item @click="handleEditVideo(video)" :disabled="!hasEditVideoPerm">
                            <v-list-item-title class="body-regular-smaller">
                              {{
                                $t(
                                  'message.pages.AssistentIntern.actions.openVideoConfig'
                                )
                              }}
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="disableChatVideo(video)" :disabled="!hasEditVideoPerm">
                            <v-list-item-title class="body-regular-smaller">
                              {{
                                $t(
                                  `message.pages.AssistentIntern.actions.${
                                    video.chat_is_visible
                                      ? 'disableChatPlayer'
                                      : 'activeChatPlayer'
                                  }`
                                )
                              }}</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item @click="removeVideoChat(video)" :disabled="!hasEditVideoPerm">
                            <v-list-item-title
                              class="body-regular-smaller removeText"
                              >{{
                                $t(
                                  'message.pages.AssistentIntern.actions.removeVideoChat'
                                )
                              }}</v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </portal>
        </div>
        <div class="grid__footer d-flex flex-column actions-column">
          <div class="divider-div">
            <v-divider></v-divider>
          </div>
          <v-row v-if="isMobileBreakpoint" class="actions-row">
            <v-col cols="5" class="pa-0 pl-3">
              <v-tooltip max-width="184px" :disabled="wasChangedSomething" top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="pl-2" v-bind="attrs" v-on="on">
                    <base-btn
                      style="width: 100%"
                      :disabled="
                        !wasChangedSomething ||
                        isFetching ||
                        isLoadingListVideos
                      "
                      type="tertiary"
                      @click="discardChanges"
                    >
                      {{ $t('message.actions.cancel') }}
                    </base-btn>
                  </div>
                </template>
                <span>{{ $t('message.noChanges') }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="6" class="pa-0">
              <v-tooltip max-width="184px" :disabled="wasChangedSomething" top>
                <template v-slot:activator="{ on, attrs }">
                  <div class="pl-2" v-bind="attrs" v-on="on">
                    <base-btn
                      style="width: 60%"
                      :disabled="
                        !wasChangedSomething ||
                        isFetching ||
                        isLoadingListVideos || !hasEditVideoPerm
                      "
                      :loading="isFetching"
                      @click="updateAssistant"
                    >
                      {{ $t('message.actions.publish') }}
                    </base-btn>
                  </div>
                </template>
                <span>{{ $t('message.noChanges') }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <div v-else class="d-flex flex-row actions-row">
            <v-spacer></v-spacer>
            <v-tooltip max-width="184px" :disabled="wasChangedSomething" top>
              <template v-slot:activator="{ on, attrs }">
                <div class="pl-2" v-bind="attrs" v-on="on">
                  <base-btn
                    style="width: 100%"
                    :disabled="
                      !wasChangedSomething || isFetching || isLoadingListVideos || !hasEditVideoPerm
                    "
                    type="tertiary"
                    @click="discardChanges"
                  >
                    {{ $t('message.actions.cancel') }}
                  </base-btn>
                </div>
              </template>
              <span>{{ $t('message.noChanges') }}</span>
            </v-tooltip>
            <v-tooltip max-width="184px" :disabled="wasChangedSomething" top>
              <template v-slot:activator="{ on, attrs }">
                <div class="pl-2" v-bind="attrs" v-on="on">
                  <base-btn
                    style="width: 100%"
                    :disabled="
                      !wasChangedSomething || isFetching || isLoadingListVideos
                    "
                    :loading="isFetching"
                    @click="updateAssistant"
                  >
                    {{ $t('message.actions.publish') }}
                  </base-btn>
                </div>
              </template>
              <span>{{ $t('message.noChanges') }}</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </template>
  </page-view>
</template>
<script>
// Components
import BaseAlert from '@/components/BaseAlert.vue'
import PageView from '@/layout/PageView_plyrPage.vue'
import AgentTabs from './AgentTabs.vue'
import EmbedModal from './embedModal.vue'
import TestModal from './TestModal.vue'
import CreatePandaAssist from '../CreatePandaAssist.vue'
import videosApi from '@/services/videosApi'

//Utils
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
import i18n from '@/translations/lang'
import { mapMutations } from 'vuex'

//API
import pandaAssist from '@/services/pandaAssist'

export default {
  name: 'Agent',
  components: {
    PageView,
    BaseHeader: () => import('@/components/BaseHeaderV2Intern.vue'),
    BaseBtn: () => import('@/components/BaseBtn.vue'),
    BaseAlert,
    AgentTabs,
    EmbedModal,
    TestModal,
    CreatePandaAssist,
  },
  data: () => ({
    loading: false,
    isLoadingListVideos: false,
    messagePreview: '',
    tabAgent: null,
    tips: [
      {
        title: 'Tom e o estilo',
        description:
          'Indique como a resposta deve soar (por exemplo, formal, amigável, motivador).',
      },
      {
        title: 'Nível de detalhamento',
        description:
          'Determine se a resposta deve ser breve, média ou completa.',
      },
      {
        title: 'Foco da resposta',
        description:
          'Defina o objetivo principal, como informar, persuadir ou apresentar exemplos.',
      },
      {
        title: 'Público-alvo',
        description:
          'Descreva para quem a resposta será direcionada (iniciantes, técnicos, clientes).',
      },
      {
        title: 'Restrições ou limites',
        description:
          'Indique qualquer limite, como tamanho máximo ou elementos a evitar.',
      },
      {
        title: 'Cenário ou contexto',
        description:
          'Adicione informações relevantes sobre a sua empresa ou produto para que a resposta seja mais personalizada.',
      },
    ],
    showInstructionTipsModal: false,
    menuVisible: false,
    menuItem: false,
    menuVideoItem: false,
    tooltipTimeout: null,
    menuVideoVisible: false,
    isTooltipVisible: false,
    isMouseOverTooltip: false,
    isTooltipVisibility: {},
    menuVisibility: {},
    dialogVisible: false,
    pollingInterval: null,
    pollingDelay: 15000,
    pandaAssistVideos: [],
    isFetching: false,
    videoMarkRemove: {},
    isRemovingVideo: false,
    isAssistantReady: false,
    updatingAgentData: false,
    hoverTooltip: false,
    menuY: 0,
    menuX: 0,
    articles: {
      pt: 'https://help.pandavideo.com/pt-br/article/pandaassist-ai-como-criar-chats-com-ia-nos-seus-videos-zdy32s/',
      en: 'https://help.pandavideo.com/en-us/article/pandaassist-ai-how-to-create-ai-chats-in-your-videos-r4624o/',
      es: 'https://help.pandavideo.com/es/article/pandaassist-ai-como-crear-chats-con-ia-en-tus-videos-1ewhd32/',
    },
    agentData: {
      name: '',
      open_new_tab: false,
      prompt: '',
      status: 'none',
      videos: [],
    },
    wasChangedSomething: false,
    agentInitialState: {},
  }),
  async mounted() {
    await this.checkIfVideosAreLoaded()
    this.loading = true
    // this.getAssistants()
    await this.getAgentInfos()
    this.$root.$on('PandaAssistUpdateVideos', (e) => {
      if (e) return (this.isLoadingListVideos = true)
      this.getAgentInfos()

      this.dialogVisible = false
      this.handleSnackbar(
        this.$i18next.t('message.pages.AssistentIntern.successAddVideo')
      )
    })
    this.loading = false
  },
  watch: {
    'agentData.status': function (newStatus) {
      if (this.disabledStatus) {
        this.disabledStatus(newStatus)
      }
    },
  },
  beforeDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    showTooltip() {
      this.isTooltipVisible = true
    },
    mouseOverErrorTooltip(videoId) {
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout)
        this.tooltipTimeout = null
      }
      this.$set(this.isTooltipVisibility, videoId, true)
    },
    async getAssistants() {
      const response = await pandaAssist.getAssistants()
      const data = response.data.filter((item) => item.status !== 'deleted')
      this.noCredits = data.some((item) => item.status === 'payment_failed')
      const videoIds = data.flatMap((item) => item.videos).map((video) => video)

      this.pandaAssistVideos = videoIds
    },
    mouseLeaveErrorTooltip(videoId) {
      this.tooltipTimeout = setTimeout(() => {
        this.$set(this.isTooltipVisibility, videoId, false)
        this.tooltipTimeout = null
      }, 1000) // Tempo de delay antes de esconder o tooltip
    },

    cancelHideTooltip(videoId) {
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout)
        this.tooltipTimeout = null
      }
      this.$set(this.isTooltipVisibility, videoId, true)
    },
    async checkIfVideosAreLoaded() {
      const allVideos = await window.db.videos.toArray()
      if (!allVideos.length) {
        const { data } = await videosApi.getAllVideosAndBin()
        const videosResponse = data.videos
        let filteredFoldersIds = []
        for (let folderId in videosResponse) {
          filteredFoldersIds.push(folderId)
        }
        await window.db.videos.clear()
        for (let folderId of filteredFoldersIds) {
          let arrToBeAdded = videosResponse[folderId].map((obj) => ({
            ...obj,
            folder_id: folderId,
          }))
          await window.db.videos.bulkPut(arrToBeAdded)
        }
      }
    },
    async pollAgentStatus() {
      if (
        this.agentData.status === 'processing' ||
        this.agentData.status === 'queued'
      ) {
        this.pollingInterval = setInterval(async () => {
          try {
            const updatedData = await pandaAssist.getAssistantById(this.agentID)
            this.agentData = { ...this.agentData, ...updatedData.data }
            if (
              this.agentData.status !== 'processing' &&
              this.agentData.status !== 'queued'
            ) {
              clearInterval(this.pollingInterval)
              const statusMap = {
                ready: true,
                disabled: false,
              }
              this.isAssistantReady = statusMap[this.agentData.status] || false
              this.pollingInterval = null
            }
          } catch (error) {
            console.error('Erro ao checar o status do assistente:', error)
            clearInterval(this.pollingInterval)
            this.pollingInterval = null
          }
        }, this.pollingDelay)
      }
    },
    hideTooltip() {
      setTimeout(() => {
        if (!this.isMouseOverTooltip) {
          this.isTooltipVisible = false
        }
      }, 200)
    },
    mouseOverTooltip() {
      this.isMouseOverTooltip = true
      this.showTooltip()
    },
    mouseLeaveTooltip() {
      this.isMouseOverTooltip = false
      this.hideTooltip()
    },
    updateStatusAgent() {
      this.agentData.status = this.isAssistantReady ? 'ready' : 'disabled'
      this.checkChanges()
    },
    async updateAssistant() {
      try {
        this.isFetching = true
        const response = await pandaAssist.updateAssistantInfo(
          this.agentData.id,
          {
            name: this.agentData.name.trim(),
            status: this.isAssistantReady ? 'ready' : 'disabled',
            openNewTab: this.agentData.open_new_tab,
            initialQuestion: this.agentData.initial_question,
            question_suggestions: this.agentData.question_suggestions,
            prompt: this.agentData.prompt,
          }
        )

        this.agentInitialState = _.cloneDeep(this.agentData)
        this.checkChanges()
        this.getAgentInfos()
        if (response?.data?.message.includes('successfully')) {
          this.handleSnackbar(
            this.$i18next.t(
              'message.pages.credits.creditsAutoRechargeModal.autoRechargeSuccess'
            )
          )
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isFetching = false
      }
    },
    openInstructionTipsModal() {
      this.showInstructionTipsModal = true
    },
    handleSnackbar(text) {
      if (!text) {
        text = i18n.t('message.navDrawer.successMessage')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text,
        type: 'success',
      })
    },
    getBack() {
      this.$root.$on('back', () => {
        this.$router.push({ name: 'Tutor' })
      })
    },
    discardChanges() {
      this.agentData = _.cloneDeep(this.agentInitialState)
      this.checkChanges()
    },
    async getAgentInfos() {
      this.isLoadingListVideos = true
      try {
        this.agentData = await pandaAssist.getAssistantById(this.agentID)
        this.agentInitialState = _.cloneDeep(this.agentData.data)
        this.agentInitialState.prompt = this.agentInitialState.prompt ?? ''
        this.agentData = _.cloneDeep(this.agentInitialState)
        const statusMap = {
          ready: true,
          disabled: false,
        }
        this.isAssistantReady = statusMap[this.agentData.status] || false
        this.pollAgentStatus()
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoadingListVideos = false
      }
    },
    openEmbedModal() {
      this.$root.$emit('openEmbedModalAgent', this.agentData)
    },
    openTestModal() {
      this.$root.$emit('openTestModalAgent', this.agentData)
    },
    checkChanges() {
      this.wasChangedSomething = !_.isEqual(
        this.agentData,
        this.agentInitialState
      )
      // if (this.agentData.status === 'disabled') {
      //   const status = this.isAssistantReady ? 'ready' : 'disabled'
      //   this.wasChangedSomething = this.agentInitialState.status !== status
      // }
    },
    handleEditVideo(video) {
      this.$router.push({
        name: 'VideoPage',
        params: { id: video.id },
      })
    },
    async disableChatVideo(video) {
      let videoDisabled = video
      console.log(video)
      try {
        const index = this.agentData.videos.findIndex(
          (item) => item.id == videoDisabled.id
        )
        this.agentData.videos[index].chat_is_visible =
          !this.agentData.videos[index].chat_is_visible
        await pandaAssist.updateChatVisibility({
          assistant_id: this.agentData.id,
          video_id: videoDisabled.id,
          chat_is_visible: this.agentData.videos[index].chat_is_visible,
        })
        this.getAgentInfos()

        this.handleSnackbar(
          this.$i18next.t(
            'message.pages.AssistentIntern.successChangeVisibilityVideo'
          )
        )
      } catch (error) {
        console.log(error)
      }
    },
    initializeTooltips() {
      this.agentData = {
        ...this.agentData,
        showTooltip: true,
        hoverTooltip: false,
      }

      setTimeout(() => {
        this.agentData = {
          ...this.agentData,
          showTooltip: false,
        }
      }, 10000)
    },
    goToEmbedArticle() {
      window.open(this.embedArticle, '_blank')
    },
    getTagType(status) {
      const statusMap = {
        queued: 'neutral',
        processing: 'neutral',
        ready: 'success',
        disabled: 'neutral',
        failed: 'error',
        payment_failed: 'error',
      }
      return statusMap[status]
    },
    disabledStatus(status) {
      const statusToDisabled = {
        queued: 'message.pages.pandaAssist.converting',
        processing: 'message.pages.pandaAssist.converting',
        disabled: 'message.pages.pandaAssist.notReady',
        payment_failed: 'message.pages.pandaAssist.error',
      }
      return !!statusToDisabled[status] // Retorna `true` se status for desativado
    },
    getStatusText(status) {
      const statusTextMap = {
        queued: 'message.pages.pandaAssist.converting',
        processing: 'message.pages.pandaAssist.converting',
        ready: 'message.pages.pandaAssist.ready',
        disabled: 'message.pages.pandaAssist.notReady',
        failed: 'message.error',
        payment_failed: 'message.pages.pandaAssist.error',
      }
      return this.$t(statusTextMap[status])
    },
    toggleHover(item, state) {
      if (!item.showTooltip) {
        this.$set(item, 'hoverTooltip', state)
      }
    },
    async removeVideoChat(video) {
      this.videoMarkRemove = video
      const newVideoList = this.agentData.videos
        .filter((video) => video.id !== this.videoMarkRemove.id)
        .map((video) => video)

      try {
        this.isRemovingVideo = true
        await pandaAssist.updateAssistantVideoBind(this.agentData.id, {
          videoIds: newVideoList,
        })
        this.agentData.videos = this.agentData.videos.filter(
          (video) => video.id !== this.videoMarkRemove.id
        )
        this.handleSnackbar(
          this.$i18next.t('message.pages.AssistentIntern.successRemovedVideo')
        )
      } catch (error) {
        console.log(error)
      } finally {
        this.isRemovingVideo = false
      }
    },
    async toggleStatus(row) {
      try {
        const newStatus = row.status === 'disabled' ? 'ready' : 'disabled'
        const response = await pandaAssist.updateAssistantInfo(row.id, {
          status: newStatus,
        })
        this.getAgentInfos()
        if (response.status === 200) {
          row.status = newStatus
          this.UPDATE_GLOBAL_SNACKBAR({
            open: true,
            type: 'success',
            text: i18n.t(
              'message.pages.credits.creditsAutoRechargeModal.autoRechargeSuccess'
            ),
          })
          this.refreshList()
        } else {
          throw new Error('Falha ao atualizar o status')
        }
      } catch (error) {
        console.error('Erro ao alternar o status:', error)
      }
    },
    async refreshList() {
      this.fetching = true
      // await this.getAssistants()
      await this.getAgentInfos()
      this.fetching = false
    },
    renameItem(agent) {
      this.$root.$emit('videoModalRenameAssist', agent)
    },
    openModalUpdateVideos() {
      this.dialogVisible = true
      this.$root.$emit('pandaAssistVideos', this.pandaAssistVideos)
      this.$root.$emit('pandaAssistAddVideos')
    },
    async removeItem(agent) {
      this.$root.$emit('deleteAssistModal', agent.id, agent.name)
    },
    beforeLeave() {
      if (!this.checkChanges()) {
        this.$root.$emit('unsavedChangesModal')
      } else {
        this.UPDATE_STATUS_ERROR(false)
        this.handleBack()
      }
    },
    openMenu(item, event) {
      const rect = event.target.getBoundingClientRect()
      this.menuItem = item
      this.menuX = rect.left + window.scrollX
      this.menuY = rect.bottom + window.scrollY + 5
      this.menuVisible = true
      this.$nextTick(() => {
        const menuRef = this.$refs.menuRef
        if (menuRef) {
          menuRef.updateDimensions()
        }
      })
    },
    openHelp() {
      window.open(this.playerSettingsArticle, '_blank')
    },
    openErrorHelp() {
      window.open(this.errorArticles, '_blank')
    },
    openSubmenuVideo(video, event) {
      const rect = event.target.getBoundingClientRect()
      this.menuVideoItem = video
      this.$set(this.menuVisibility, video.id, true)
      this.menuX = rect.left + window.scrollX
      this.menuY = rect.bottom + window.scrollY + 5
    },
  },
  computed: {
    ...mapState('user', {
      userPlanInfo: 'userPlanInfo',
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    ...mapGetters('user', ['hasEditVideoPerm']),
    pageViewHeight() {
      return this.isMobileBreakpoint
        ? 'calc(100vh - 106px)'
        : 'calc(100vh - 56px)'
    },
    locale() {
      return this.$i18next.resolvedLanguage
    },
    playerSettingsArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/pandaassist-ai-how-to-create-ai-chats-in-your-videos-r4624o/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/pandaassist-ai-como-crear-chats-con-ia-en-tus-videos-1ewhd32/'
      }
      return 'https://help.pandavideo.com/pt-br/article/pandaassist-ai-como-criar-chats-com-ia-nos-seus-videos-zdy32s/'
    },
    errorArticles() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/pandaassist-ai-how-to-create-ai-chats-in-your-videos-r4624o/?bust=1737991264611#2-6-possible-errors-in-pandaassist-ai-generation'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/pandaassist-ai-como-crear-chats-con-ia-en-tus-videos-1ewhd32/?bust=1737991489821#2-6-posibles-errores-en-la-generacion-del-pandaassist-ai'
      }
      return 'https://help.pandavideo.com/pt-br/article/pandaassist-ai-como-criar-chats-com-ia-nos-seus-videos-zdy32s/?bust=1737991069940#2-6-possiveis-erros-na-geracao-do-pandaassist-ai'
    },
    embedArticle() {
      switch (this.locale) {
        case 'pt-BR':
        case 'pt':
          return this.articles.pt
        case 'es':
          return this.articles.es
        case 'en':
        default:
          return this.articles.en
      }
    },
    checkStatus() {
      if (this.agentData.status === 'ready') return true
      return false
    },
    agentID() {
      const id = this.$router?.history?.current?.params?.id
      return id
    },
  },
}
</script>
<style lang="scss">
//reset v-input and v-btn borders for send message component

.preview__chat--send-message {
  .v-text-field--outlined {
    fieldset {
      border: none !important;

      &:hover {
        border: none !important;
      }
    }
    input {
      cursor: default;
    }
  }
  .base-input.v-input.v-input--is-focused fieldset {
    border: none !important;
  }
  .v-btn:not(.v-btn--round).v-size--default {
    min-width: 0;
    padding: 0 8px;
    font-size: 20px;
    background-color: #fff;
  }
}
</style>
<style lang="scss" scoped>
@import '~vuetify/src/components/VStepper/_variables.scss';
.cursor-pointer {
  cursor: pointer;
}
.truncate-text {
  display: inline-block;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
.helper-cursor-pointer {
  cursor: pointer;
  color: varFigma(neutral-60);
}

.disabledText {
  color: varFigma(neutral-70);
}

.indexNumber {
  font-size: 12px;
  font-weight: 500;
  min-height: 22px;
  min-width: 22px;
  background: varFigma(brand-90);
  color: varFigma(brand-20-darkest);
  border-radius: 50%;
  margin-right: 8px;
  align-items: center;
  justify-content: center;
  align-self: center;
  display: flex;
}

.nalps {
  width: 16px;
  height: 16px;
  margin-top: 1px;
  border: 2px solid varFigma(neutral-80-lighter);
  border-radius: 50%;
  border-top: 2px solid varFigma(brand-60-base);
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.removeText {
  color: varFigma(feedback-danger);
}
.cursor-default {
  cursor: default;
  height: auto;
  text-align: left;
  background: varFigma(neutral-95-lightest);
  padding: 4px 8px;
  border-radius: 4px;
  min-width: 80px;
}
.pandaGo {
  color: varFigma(neutral-30-base);
  margin-left: 5px;
}
.titleAgentIntern {
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
}
.featTitle {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: varFigma(neutral-20-dark);
}
.subtitleAgentIntern,
.featSubtitle {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: varFigma(neutral-40-light);
  .link {
    font-weight: 500;

    .v-icon {
      color: varFigma(neutral-40-light);
      font-size: 12px;
    }
  }
}

.grid {
  display: grid;
  grid-template-areas: 'preview' 'control' 'spacer' 'footer';
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  column-gap: 0;
  row-gap: 0;

  box-shadow: none !important;

  overflow: hidden;
  height: 100%;

  @media (min-width: 1200px) {
    grid-template-areas:
      'preview control'
      'preview spacer'
      'preview footer';
    grid-template-columns: 50% auto;
    grid-template-rows: auto 1fr auto;
  }

  &__preview {
    grid-area: preview;
    overflow: hidden;
    padding: $spacing-10;
    border-right: 1px solid varFigma(neutral-95-lightest) !important;
    background-color: varFigma(neutral-background);

    &--container {
      margin: 0 auto;
      width: 75vw;

      @media (min-width: 760px) {
        width: 100vw;
      }

      @media (min-width: 1200px) {
        width: 100%;
      }
    }
  }

  &__control {
    grid-area: control;

    overflow-y: auto;
    overflow-x: hidden;

    height: 100%;
    padding: $spacing-10 $spacing-09 0 $spacing-09;
    margin-right: 2px;

    @media (max-width: 1199px) {
      border-top: 1px solid varFigma(neutral-95-lightest) !important;
    }

    &--items {
      display: grid;
      padding-top: 0 !important;
    }
    &--item {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px !important;
      &:hover {
        background-color: varFigma(neutral-99);
      }
      & .v-input::v-deep {
        padding: 0 !important;
        & .v-input--selection-controls__input {
          margin-right: 0 !important;
        }
      }
    }
  }

  &__footer {
    grid-area: footer;

    @media (width >= 1200px) {
      border-left: 1px solid varFigma(neutral-95-lightest) !important;

      & .actions-row {
        margin-right: 100px;
      }
    }
    @media (width < 1200px) {
      & .actions-row {
        .spacer {
          display: none;
        }

        justify-content: center;
      }
    }
    & .actions-row {
      padding: $spacing-07 0;
    }
    &.actions-column {
      .divider-div {
        padding: 0 $spacing-10;
      }
    }
  }

  &__spacer {
    grid-area: spacer;
    @media (width >= 1200px) {
      border-left: 1px solid varFigma(neutral-95-lightest) !important;
    }
  }

  &__resources {
    &--items {
      display: grid;
      padding-top: 0 !important;
    }
    &--item {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px !important;
      &:hover {
        background-color: varFigma(neutral-99);
        &.affiliate {
          background-color: inherit;
        }
      }
      & .v-input::v-deep {
        padding: 0 !important;
        & .v-input--selection-controls__input {
          margin-right: 0 !important;
        }
      }
    }
    &--label {
      display: flex;
      flex-direction: column;
      align-items: start;
      .body-regular-smaller {
        color: varFigma(neutral-40-light);
      }
    }
  }
}
.preview {
  height: 83%;
  margin: 0;

  &__chat {
    width: 100%;
    height: 500px;
    background-color: varFigma(neutral-30-base);

    &--title {
      background-color: varFigma(neutral-0-darkest);
      border: 1px solid varFigma(neutral-80-lighter);
      border-bottom: 0;
      color: varFigma(neutral-100-white);

      .v-icon {
        color: varFigma(neutral-100-white);
      }
    }
    &--chat {
      background-color: varFigma(neutral-95);
      padding: 16px;
      display: flex;
      flex-direction: column;
      border-left: 1px solid varFigma(neutral-80-lighter);
      border-right: 1px solid varFigma(neutral-80-lighter);
      gap: 16px;
      height: 100%;

      &-bot {
        padding: 8px;
        border-radius: 8px 8px 8px 0;
        background-color: varFigma(neutral-40-light);
        width: 50%;

        .message {
          color: varFigma(neutral-95-lightest);
        }
      }

      &-suggestions {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-content: end;
        flex-wrap: wrap;

        div {
          background-color: varFigma(neutral-100-white);
          max-width: 80%;
          flex-wrap: wrap;
          text-align: left;
          display: flex;
          flex-direction: column;
          align-content: start;
          border-radius: 8px;
          gap: 16px;

          .suggestion-btn {
            width: 100% !important;

            .base-button--small {
              color: varFigma(neutral-30-base-base);
            }
            .base-button--small:hover {
              background-color: varFigma(neutral-95-lightest);
              border-color: varFigma(neutral-95-lightest);
              color: varFigma(neutral-30-base-base);
            }
          }
        }
      }
    }

    &--send-message {
      padding: 16px;
      display: flex;
      border: 1px solid varFigma(neutral-80-lighter);
      background-color: varFigma(neutral-100-white);
      border-top: 0px;
    }
  }
  &__advice {
    height: 100%;

    &--message {
      width: 100%;
      background-color: varFigma(neutral-0-darkest);
      border-radius: 8px;
      padding: 8px;

      span {
        color: varFigma(neutral-95-lightest);
      }
    }
  }
}
.plyr-page-view-content-css {
  overflow-y: hidden !important;
  padding: 0 !important;
  margin: 0 !important;
  @media (min-width: 1200px) {
    background: linear-gradient(
      to right,
      varFigma(neutral-background) 50%,
      varFigma(neutral-background) 50%,
      varFigma(neutral-100-white) 50%,
      varFigma(neutral-100-white) 100%
    );
  }
}

// logica para width menor que 1334px
@media (max-width: 1380px) {
  .instructionsBtn {
    height: 44px;
  }
}

.plyr-page-view-header-css {
  border-bottom: 1px solid varFigma(neutral-95-lightest) !important;
  height: 56px !important;
  & header {
    min-height: 100% !important;
  }
}
.plyr-page-view-container-css {
  grid-template-rows: 56px 1fr !important;
}
@media screen and (max-width: 900px) {
  .plyr-page-view-header-css {
    border-bottom: 1px solid varFigma(neutral-95-lightest) !important;
    height: 106px !important;
    & header {
      flex-direction: column;
      width: 100%;
      min-height: 100% !important;
      &::v-deep {
        .header__actions {
          flex-direction: column;
          width: 100%;
        }
      }
    }
  }
  .actions-column {
    height: 76px;
    &::v-deep {
      .actions-row {
        align-items: center;
      }
    }
  }
  .plyr-page-view-container-css {
    grid-template-rows: 106px 1fr !important;
  }
  .featSubtitle {
    max-width: 220px;
  }
}
.header__back {
  width: 40px;
  height: 40px;
  flex: 0 1 auto;
  &--icon {
    cursor: pointer;
    .v-icon {
      color: varFigma(neutral-40-light);
    }
    &:hover {
      border-radius: var(--spacing-02, 4px);
      background-color: varFigma(neutral-99);
    }
  }
}
</style>
